import React from 'react';
import classnames from 'classnames';
import { useScrollCounter } from '../hooks/useScrollCounter';
import { useDotsIndicators } from './useDotsIndicators';

import './index.scss';

export interface SlidesIndicatorProps {
    className: string;
    slidesToShow: number;
    currentPosition: ReturnType<typeof useScrollCounter>['currentPosition'];
    slides: any[];
}

export const SlidesIndicator: React.FC<SlidesIndicatorProps> = ({
    className,
    slidesToShow = 1,
    currentPosition,
    slides = []
}) => {
    const { edgeDotsIdx, hiddenDotsIdx } = useDotsIndicators({ currentPosition, slidesToShow, slides });

    const dotElements = slides.map((_, index) => {
        const edgeDot = edgeDotsIdx.includes(index);
        const isActive = currentPosition === index;
        const hiddenDot = hiddenDotsIdx.includes(index);

        return (
            <span key={index}
                className={classnames('slider-dot-item', {
                    'item-active-position': isActive,
                    'item-edge-position': edgeDot,
                    'item-hidden-position': hiddenDot
                })}/>
        );
    });

    return (
        <div className={classnames('carousel-slides-indicator flex flex-center')}>
            <div className={classnames(className, 'slider-indicator flex flex-items-center')}>{dotElements}</div>
        </div>
    );
};
